import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { AxiosResponse } from "axios";
import config from "../url/config";
import { api } from "../utils/hostname";
import * as userSelectors from "../redux/user/selectors";
import { Loyalty } from "../types/Loyalty";

export const useGetLoyaltyUser = () => {
  const userId = useSelector(userSelectors.id);

  return useQuery<AxiosResponse<{ data: Loyalty }>>({
    queryKey: ["loyalty user", userId],
    queryFn: () => api(true, true).get(config.api.loyalty.loyaltyUser),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    enabled: userId !== null,
  });
};
